(function () {
  'use strict';

  /**
   * Crest Builder — manages modal step flow, design selection,
   * form validation, canvas preview, and hidden Shopify line-item inputs.
   */

  // Find the modal on the page
  const modal = document.querySelector('[id^="CrestBuilderModal-"]');
  if (!modal) return;

  const sectionId = modal.id.replace('CrestBuilderModal-', '');

  // ───── DOM refs ─────
  const steps = modal.querySelectorAll('[data-crest-step]');
  const dots = modal.querySelectorAll('.crest-builder__step-dot');
  const lines = modal.querySelectorAll('.crest-builder__step-line');
  const designCards = modal.querySelectorAll('.crest-builder__design-card');
  const backBtns = modal.querySelectorAll('[data-crest-back]');
  const nextBtn = modal.querySelector('[data-crest-next]');
  const addBtn = modal.querySelector('[data-crest-add]');
  const canvas = document.getElementById('crest-preview-canvas-' + sectionId);

  // Form inputs inside modal
  const inputName = document.getElementById('CrestName-' + sectionId);
  const inputCity = document.getElementById('CrestCity-' + sectionId);
  const inputState = document.getElementById('CrestState-' + sectionId);
  const inputYear = document.getElementById('CrestYear-' + sectionId);

  // Hidden Shopify properties (outside modal, associated with product form)
  const propDesign = document.getElementById('CrestPropDesign-' + sectionId);
  const propName = document.getElementById('CrestPropName-' + sectionId);
  const propCity = document.getElementById('CrestPropCity-' + sectionId);
  const propState = document.getElementById('CrestPropState-' + sectionId);
  const propYear = document.getElementById('CrestPropYear-' + sectionId);
  const propToken = document.getElementById('CrestPropToken-' + sectionId);

  // Summary block (outside modal, on PDP)
  const summary = document.querySelector('.mahj-crest-summary');
  const summaryDesign = summary ? summary.querySelector('[data-crest-summary-design]') : null;
  const summaryInfo = summary ? summary.querySelector('[data-crest-summary-info]') : null;
  const triggerBtn = document.querySelector('.mahj-crest-trigger');

  // ───── Config (preview image URLs + text positioning) ─────
  var configEl = document.getElementById('crest-builder-config-' + sectionId);
  var config = configEl ? JSON.parse(configEl.textContent) : null;

  // Preload preview images
  var previewImages = {};
  if (config) {
    Object.keys(config.designs).forEach(function (key) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = config.designs[key].previewUrl;
      previewImages[key] = img;
    });
  }

  // ───── Saved crests (Step 0) ─────
  var savedCrestsEl = document.getElementById('saved-crests-' + sectionId);
  var savedCrests = savedCrestsEl ? JSON.parse(savedCrestsEl.textContent) : [];
  var hasSavedCrests = savedCrests.length > 0;
  var savedGrid = document.getElementById('crest-saved-grid-' + sectionId);
  var createNewBtn = modal.querySelector('[data-crest-create-new]');

  // Build saved crest cards
  if (hasSavedCrests && savedGrid) {
    savedCrests.forEach(function (crest, idx) {
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'crest-builder__saved-card';
      card.setAttribute('data-saved-idx', idx);

      var designLabel = crest.design === 'swirls' ? 'Swirls' : 'Bamboo';
      var locationParts = [];
      if (crest.city) locationParts.push(crest.city);
      if (crest.state) locationParts.push(crest.state);
      var location = locationParts.join(', ');

      card.innerHTML =
        (crest.previewUrl ? '<img class="crest-builder__saved-img" src="' + crest.previewUrl + '" alt="' + crest.groupName + '" loading="lazy">' : '<div class="crest-builder__saved-img crest-builder__saved-img--placeholder">' + designLabel + '</div>') +
        '<span class="crest-builder__saved-name">' + crest.groupName + '</span>' +
        (location ? '<span class="crest-builder__saved-detail">' + location + '</span>' : '');

      card.addEventListener('click', function () {
        selectSavedCrest(crest);
      });

      savedGrid.appendChild(card);
    });
  }

  // "Create New Crest" button
  if (createNewBtn) {
    createNewBtn.addEventListener('click', function () {
      // Redirect to the standalone creator page (which handles its own auth).
      // After creating, the customer comes back to PDPs and their new crest
      // will appear in the saved crests list.
      var returnTo = window.location.pathname + window.location.search;
      window.location.href = '/pages/group-crest-creator?return_to=' + encodeURIComponent(returnTo);
    });
  }

  function selectSavedCrest(crest) {
    // Populate hidden inputs
    propDesign.value = crest.design || '';
    propName.value = crest.groupName || '';
    propCity.value = crest.city || '';
    propState.value = crest.state || '';
    propYear.value = crest.year || '';
    if (propToken) propToken.value = crest.shareToken || '';

    // Enable hidden inputs
    propDesign.disabled = false;
    propName.disabled = false;
    propCity.disabled = false;
    propState.disabled = false;
    if (propYear.value) {
      propYear.disabled = false;
    } else {
      propYear.disabled = true;
    }
    if (propToken && propToken.value) propToken.disabled = false;

    // Set internal state for summary
    selectedDesign = crest.design;

    // Show summary + close modal
    showSummary();
    modal.hide();
  }

  // ───── State ─────
  var startStep = hasSavedCrests ? 0 : 1;
  let currentStep = startStep;
  let selectedDesign = null;

  // ───── Step navigation ─────
  function goToStep(step) {
    currentStep = step;
    steps.forEach(function (el) {
      var s = parseInt(el.getAttribute('data-crest-step'), 10);
      if (s === step) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
    // Hide step indicators on Step 0 (saved crests view)
    var stepsIndicator = modal.querySelector('.crest-builder__steps-indicator');
    if (stepsIndicator) {
      stepsIndicator.style.display = step === 0 ? 'none' : '';
    }
    updateStepIndicators();

    if (step === 3) {
      renderPreview();
    }
  }

  function updateStepIndicators() {
    dots.forEach(function (dot) {
      var s = parseInt(dot.getAttribute('data-step'), 10);
      dot.classList.remove('is-active', 'is-done');
      if (s === currentStep) {
        dot.classList.add('is-active');
      } else if (s < currentStep) {
        dot.classList.add('is-done');
      }
    });
    // Lines between dots
    var lineArr = Array.from(lines);
    for (var i = 0; i < lineArr.length; i++) {
      if (i + 1 < currentStep) {
        lineArr[i].classList.add('is-done');
      } else {
        lineArr[i].classList.remove('is-done');
      }
    }
  }

  // ───── Step 1: Design selection ─────
  designCards.forEach(function (card) {
    card.addEventListener('click', function () {
      selectedDesign = card.getAttribute('data-design');
      designCards.forEach(function (c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');
      // Auto-advance to step 2 after a brief visual beat
      setTimeout(function () { goToStep(2); }, 200);
    });
  });

  // ───── Step 2: Validation + navigation ─────
  function validateStep2() {
    var name = inputName.value.trim();
    var city = inputCity.value.trim();
    var state = inputState.value.trim();
    return name.length > 0 && city.length > 0 && state.length > 0;
  }

  function updateNextBtnState() {
    if (nextBtn) {
      nextBtn.disabled = !validateStep2();
    }
  }

  [inputName, inputCity, inputState, inputYear].forEach(function (inp) {
    if (inp) inp.addEventListener('input', updateNextBtnState);
  });

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      if (validateStep2()) {
        goToStep(3);
      }
    });
  }

  // Back buttons
  backBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      goToStep(currentStep - 1);
    });
  });

  // ───── Step 3: Preview ─────
  function renderPreview() {
    if (!canvas || !config) return;
    var ctx = canvas.getContext('2d');
    var design = selectedDesign || 'bamboo';
    var designConfig = config.designs[design];
    if (!designConfig) return;

    var img = previewImages[design];
    if (!img) return;

    // Wait for image to load before drawing
    if (!img.complete) {
      img.onload = function () { renderPreview(); };
      return;
    }

    // Size canvas to match image aspect ratio
    var canvasW = 400;
    var canvasH = Math.round(canvasW * img.naturalHeight / img.naturalWidth);
    canvas.width = canvasW;
    canvas.height = canvasH;

    // Dark background so cream artwork is visible
    ctx.fillStyle = '#1a1a1a';
    ctx.fillRect(0, 0, canvasW, canvasH);

    // Draw crest artwork
    ctx.drawImage(img, 0, 0, canvasW, canvasH);

    // Text color — cream to match artwork on dark bg
    var textColor = '#EDE7DA';

    // Draw group name
    var name = inputName.value.trim().toUpperCase();
    var nameFontSize = Math.round(canvasW * designConfig.name.fontSizeRatio);
    ctx.fillStyle = textColor;
    ctx.font = designConfig.name.fontWeight + ' ' + nameFontSize + 'px Poppins, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.letterSpacing = designConfig.name.letterSpacing + 'em';
    ctx.fillText(name, canvasW / 2, canvasH * designConfig.name.yRatio);

    // Draw city, state
    var city = inputCity.value.trim();
    var state = inputState.value.trim();
    var location = (city + ', ' + state).toUpperCase();
    var cityFontSize = Math.round(canvasW * designConfig.cityState.fontSizeRatio);
    ctx.font = designConfig.cityState.fontWeight + ' ' + cityFontSize + 'px Poppins, sans-serif';
    ctx.letterSpacing = designConfig.cityState.letterSpacing + 'em';
    ctx.fillText(location, canvasW / 2, canvasH * designConfig.cityState.yRatio);

    // Draw year (only if provided)
    var year = inputYear.value.trim();
    if (year) {
      var yearFontSize = Math.round(canvasW * designConfig.year.fontSizeRatio);
      ctx.font = designConfig.year.fontWeight + ' ' + yearFontSize + 'px Poppins, sans-serif';
      ctx.letterSpacing = designConfig.year.letterSpacing + 'em';
      ctx.fillText('EST. ' + year, canvasW / 2, canvasH * designConfig.year.yRatio);
    }

    // Reset letterSpacing
    ctx.letterSpacing = '0px';

    // Update preview details below canvas
    var previewName = modal.querySelector('[data-crest-preview-name]');
    var previewLoc = modal.querySelector('[data-crest-preview-location]');
    if (previewName) previewName.textContent = inputName.value.trim();
    if (previewLoc) {
      var locText = city + ', ' + state;
      if (year) locText += ' \u2022 EST. ' + year;
      previewLoc.textContent = locText;
    }
  }

  // ───── Add Crest (submit from modal) ─────
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      // Populate hidden Shopify inputs
      propDesign.value = selectedDesign || '';
      propName.value = inputName.value.trim();
      propCity.value = inputCity.value.trim();
      propState.value = inputState.value.trim();
      propYear.value = inputYear.value.trim();

      // Enable hidden inputs so they submit with the form
      propDesign.disabled = false;
      propName.disabled = false;
      propCity.disabled = false;
      propState.disabled = false;
      // Only enable year if it has a value
      if (propYear.value) {
        propYear.disabled = false;
      } else {
        propYear.disabled = true;
        propYear.value = '';
      }

      // Update summary
      showSummary();

      // Close modal
      modal.hide();
    });
  }

  // ───── Summary (on PDP) ─────
  function showSummary() {
    if (!summary || !triggerBtn) return;

    var designLabel = selectedDesign === 'swirls' ? 'Swirls' : 'Bamboo';
    var name = propName.value;
    var city = propCity.value;
    var state = propState.value;
    var year = propYear.value;

    if (summaryDesign) summaryDesign.textContent = 'Design: ' + designLabel;
    if (summaryInfo) {
      var info = name + ' \u2014 ' + city + ', ' + state;
      if (year) info += ' \u2022 EST. ' + year;
      summaryInfo.textContent = info;
    }

    summary.classList.add('is-active');
    triggerBtn.classList.add('is-hidden');
  }

  function hideSummary() {
    if (!summary || !triggerBtn) return;
    summary.classList.remove('is-active');
    triggerBtn.classList.remove('is-hidden');
  }

  // Edit button — reopen modal with values populated
  var editBtn = summary ? summary.querySelector('[data-crest-edit]') : null;
  if (editBtn) {
    editBtn.addEventListener('click', function () {
      // Re-select the design card
      if (propDesign.value) {
        selectedDesign = propDesign.value;
        designCards.forEach(function (c) {
          c.classList.toggle('is-selected', c.getAttribute('data-design') === selectedDesign);
        });
      }
      // Populate form fields from hidden inputs
      inputName.value = propName.value;
      inputCity.value = propCity.value;
      inputState.value = propState.value;
      inputYear.value = propYear.value;

      goToStep(1);
      updateNextBtnState();

      // Open modal
      modal.show(editBtn);
    });
  }

  // Remove button — clear everything
  var removeBtn = summary ? summary.querySelector('[data-crest-remove]') : null;
  if (removeBtn) {
    removeBtn.addEventListener('click', function () {
      // Clear hidden inputs and disable them
      propDesign.value = '';
      propDesign.disabled = true;
      propName.value = '';
      propName.disabled = true;
      propCity.value = '';
      propCity.disabled = true;
      propState.value = '';
      propState.disabled = true;
      propYear.value = '';
      propYear.disabled = true;
      if (propToken) {
        propToken.value = '';
        propToken.disabled = true;
      }

      // Clear form fields
      inputName.value = '';
      inputCity.value = '';
      inputState.value = '';
      inputYear.value = '';

      // Reset design selection
      selectedDesign = null;
      designCards.forEach(function (c) { c.classList.remove('is-selected'); });

      // Reset to start step (0 if saved crests, 1 otherwise)
      goToStep(startStep);
      updateNextBtnState();

      // Hide summary, show trigger
      hideSummary();
    });
  }

  // Trigger button — open modal fresh
  if (triggerBtn) {
    triggerBtn.addEventListener('click', function () {
      // Auth gate — Group Crest requires a logged-in customer
      var loggedIn = triggerBtn.dataset.customerLoggedIn === 'true';
      if (!loggedIn) {
        // Open the modal showing the login-required view instead of redirecting away
        goToLoginView();
        modal.show(triggerBtn);
        return;
      }
      goToStep(startStep);
      updateNextBtnState();
      modal.show(triggerBtn);
    });
  }

  // ───── Login required view ─────
  function goToLoginView() {
    steps.forEach(function (el) {
      var s = el.getAttribute('data-crest-step');
      if (s === 'login') {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
    // Hide step indicators on login view
    var stepsIndicator = modal.querySelector('.crest-builder__steps-indicator');
    if (stepsIndicator) stepsIndicator.style.display = 'none';
  }

  // Login button inside modal — preserves return_to with PDP context
  var loginInModalBtn = modal.querySelector('[data-crest-login-btn]');
  if (loginInModalBtn) {
    loginInModalBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var returnTo = window.location.pathname + window.location.search;
      window.location.href = '/account/login?return_to=' + encodeURIComponent(returnTo);
    });
  }

  // ───── Init ─────
  goToStep(1);
  updateNextBtnState();
})();
